import { useTheme } from '@mui/material'

interface GROBxLogoProps {
  size?: number
}

const GROBxLogo = ({ size = 48 }: GROBxLogoProps) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  return (
    <svg viewBox="1 6.5 22 17.5" width={size} height={size} fill="none" aria-hidden="true">
      {/* Green block — bottom left */}
      <rect x="1.5" y="17.5" width="7" height="6" rx="1.2" fill="#43A047" />
      {/* Dark blue block — middle center */}
      <rect x="10" y="11.5" width="6" height="5" rx="1.2" fill={isDark ? '#1D4E89' : '#1D4E89'} />
      {/* Blue block — bottom center */}
      <rect x="10" y="18" width="6" height="5.5" rx="1.2" fill="#0066DC" />
      {/* Red block — top right */}
      <rect x="17.5" y="7" width="5" height="4.5" rx="1" fill="#D95F55" />
      {/* Orange block — middle right */}
      <rect x="17.5" y="13" width="5" height="4.5" rx="1" fill="#F29112" />
      {/* Yellow block — bottom right */}
      <rect x="17.5" y="19" width="5" height="4.5" rx="1" fill="#FFB703" />
    </svg>
  )
}

export default GROBxLogo
